var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTophalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 42,
    viewBox: "0 0 21 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1708",
    d: "M20.6615 41.3215C17.9483 41.3215 15.2616 40.7871 12.755 39.7488C10.2483 38.7105 7.97065 37.1887 6.05212 35.2701C4.13359 33.3516 2.61173 31.074 1.57343 28.5673C0.53513 26.0606 0.000725071 23.374 0.000725039 20.6608C0.000725007 17.9476 0.535134 15.2609 1.57343 12.7542C2.61173 10.2476 4.13359 7.96993 6.05212 6.0514C7.97065 4.13287 10.2483 2.61101 12.755 1.57271C15.2616 0.534406 17.9483 4.15355e-08 20.6615 2.46377e-07L20.6615 2.39616C18.263 2.39616 15.8879 2.86859 13.6719 3.78647C11.456 4.70435 9.44249 6.04972 7.74647 7.74574C6.05044 9.44177 4.70508 11.4552 3.7872 13.6712C2.86932 15.8872 2.39689 18.2622 2.39689 20.6608C2.39689 23.0593 2.86932 25.4344 3.7872 27.6503C4.70508 29.8663 6.05044 31.8798 7.74647 33.5758C9.44249 35.2718 11.456 36.6172 13.6719 37.5351C15.8879 38.4529 18.263 38.9254 20.6615 38.9254L20.6615 41.3215Z",
    fill: "#71DDB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTophalf);
export default __webpack_public_path__ + "static/media/tophalf.dc3d5ee34e2b7769b5ece7b374cad03f.svg";
export { ForwardRef as ReactComponent };